<template>
  <v-tour
    name="basicTour"
    :callbacks="tourCallbacks"
    :steps="tourSteps"
    :options="tourOptions"
  ></v-tour>
</template>

<script>
  export default {
    name: 'TourGuide',
    data () {
      return {
        localStorageStopKey: 'ARTIFACTS_GENERATOR_TOUR_GUIDE',
        tourCallbacks: {
          onStop: this.persistStopAction,
          onNextStep: this.onNextStep
        },
        tourOptions: {
          useKeyboardNavigation: true,
          labels: {
            buttonSkip: 'Sair do guia',
            buttonPrevious: 'Anterior',
            buttonNext: 'Próximo',
            buttonStop: 'Finalizar'
          }
        },
        tourSteps: [
          {
            target: '.basic-tour',
            content: `
              Seja bem vindo à <strong>Forja Mística</strong>!<br/><br/>
              Se é a sua primeira vez aqui, clique em próximo para seguir o nosso guia.
            `,
            params: {
              placement: 'bottom'
            }
          },
          {
            target: '.artifacts-generator',
            content: `A criação é composta de 4 etapas:
              mecânicas, aparência, nome e materialização`,
            params: {
              placement: 'bottom'
            }
          },
          {
            target: '.options-left',
            content: `<strong>Propriedades</strong><br/><br/>
              Nesta aba você poderá adicionar e modificar as propriedades
              e mecânicas do seu artefato.<br/><br/>
              Práticando: modifique as mecânicas como achar melhor.`,
            params: {
              placement: 'right'
            }
          },
          {
            target: '.editor-center',
            content: `<strong>Pré-visualização</strong><br/><br/>
              Este é um vislumbre de como seu artefato ficará quando for
              materializado (impresso).`,
            params: {
              placement: 'right'
            }
          },
          {
            target: '.options-right',
            content: `<strong>Aparência</strong><br/><br/>
              Aqui você irá escolher, posicionar e enquadrar a
              imagem do seu artefato. Você também pode trocar a cor de fundo se
              quiser ;)<br/><br/>
              Práticando: selecione uma imagem e modifique como achar melhor.`,
            params: {
              placement: 'left'
            }
          },
          {
            target: '.generate-options',
            content: `<strong>Nome e Criação</strong><br/><br/>
              Aqui você poderá dar um nome para o seu artefato e após isto
              criá-lo.<br/><br/>
              Práticando: Dê um nome para o artefato e clique em
              <strong>Criar artefato</strong>.`
          },
          {
            target: '.generated-items-list',
            content: `<strong>Lista de artefatos criados</strong><br/><br/>
              Você pode <strong>remover</strong>,
              <strong>alterar</strong> e até mesmo <strong>baixar</strong>
              o artefato em formato de imagem.`,
            params: {
              highlight: true,
              placement: 'left'
            }
          },
          {
            target: '.export-to-pdf',
            content: `<strong>Materializar artefatos</strong><br/><br/>
              Quando tudo estiver pronto, basta Materializar seus artefatos!<br/>
              (Eles serão unidos em um arquivo pronto para impressão)`,
            params: {
              highlight: true,
              placement: 'top'
            }
          },
          {
            target: '.export-import-items',
            content: `Para finalizar, você também pode exportar seu progresso
              e importá-lo depois utilizando estes controles.`,
            params: {
              highlight: true
            }
          }
        ]
      }
    },
    mounted: function () {
      const tourOnLocalStorage = localStorage.getItem(this.localStorageStopKey)

      if (tourOnLocalStorage !== 'done') {
        this.$tours['basicTour'].start()
      }
    },
    methods: {
      persistStopAction() {
        localStorage.setItem(this.localStorageStopKey, 'done')
      },
      onNextStep(currentStep) {
        if (currentStep === 7) {
          this.persistStopAction()
        }
      }
    }
  }
</script>